export default {
  getCalendar(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/events/calendar?${queryString}&limit=999`)
        .then(response => {
          context.commit("setCalendar", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getAll(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/events")
        .then(response => {
          context.commit("setNotifications", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getAll(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/events")
        .then(response => {
          context.commit("setNotifications", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  makeRead(context, notifications_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/events/make-read", { notifications_id })
        .then(resolve)
        .catch(reject);
    });
  }
};
